'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file Component to use Google Tag Manager on the page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var GoogleTagManager = function (_React$Component) {
  _inherits(GoogleTagManager, _React$Component);

  function GoogleTagManager() {
    _classCallCheck(this, GoogleTagManager);

    return _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).apply(this, arguments));
  }

  _createClass(GoogleTagManager, [{
    key: 'componentDidMount',


    /**
     * Calling the GTM snippet should make sure that the code and the DOM
     * changes are executed once after loading the component. (That's the
     * theory, anyways)
     */
    value: function componentDidMount() {
      //region Code Snippet from Google
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', this.props.gtmId);
      //endregion
    }

    /**
     * Renders the noscript fallback.
     *
     * Does rendering something using a noscript tag make much sense? Not at
     * first, but according to
     * https://twitter.com/bockph/status/793399813089923072 it can be useful
     * in isomorphic environments (where parts of the code is rendered on the
     * server).
     *
     * @returns {null | XML}
     */

  }, {
    key: 'render',
    value: function render() {

      if (this.props.gtmId === '') {
        return null;
      }

      return _react2.default.createElement(
        'noscript',
        null,
        _react2.default.createElement('iframe', {
          src: '//www.googletagmanager.com/ns.html?id=' + this.props.gtmId,
          height: '0', width: '0',
          style: { display: 'none', visibility: 'hidden' } })
      );
    }
  }]);

  return GoogleTagManager;
}(_react2.default.Component);

GoogleTagManager.propTypes = {
  gtmId: _react2.default.PropTypes.string.isRequired
};

GoogleTagManager.defaultProps = {};

exports.default = GoogleTagManager;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-gtm/dist/index.js
// module id = 93
// module chunks = 0